<template>
  <div class="container flex flex-center flex-item-center">
    <div class="chat-panel" v-if="page.isToken">
      <!-- 机器人会话 -->
      <robot-session
        v-if="page.pageStatus === 1"
        :show-type="page.pageStatus"
        :app-info="page.appInfo"
        :cust-info="page.custInfo"
        :service-style="page.serviceStyle"
        ref="robotRef"
        @switch="handleSwitchService"
      />
      <!-- 在线客服会话 -->
      <service-session
        v-if="page.pageStatus === 2"
        :cust-info="page.custInfo"
        :app-info="page.appInfo"
        :client-info="page.clientInfo"
        :service-style="page.serviceStyle"
        :show-type="page.pageStatus"
        :close-session-enable="page.closeSessionEnable"
        :robot-enable="page.robotEnable"
        ref="serviceRef"
        @switch="handleSwitchRobot"
        @reconnect="hanldeReconnect"
        @quitChat="handleQuitChat"
        @reconnnectService="connnectService"
      />
    </div>
    <!-- 授权 -->
    <chat-msg-authorize @init="handleSetCustInfo" ref="chatMsgAuthorizeRef" />
    <!-- 会话邀请 -->
    <chat-invite ref="inviteRef" :invite-style="page.serviceStyle.inviteStyle" @accept="handleAccept" />
  </div>
</template>

<script setup>
import * as utils from '../utils/index.js'
import ServiceSession from './common/serviceSession.vue'
import RobotSession from './common/robotSession.vue'
import ChatMsgAuthorize from './common/ChatMsgAuthorize.vue'
import ChatInvite from './common/ChatInvite.vue'
import { reactive, getCurrentInstance, computed, nextTick, ref, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { isMobile, isWx, isSameDay } from '@/utils/index'
const { proxy } = getCurrentInstance()
const route = useRoute()
const page = reactive({
  pageStatus: 1, //1接入机器人 2接入客服
  custInfo: {}, //客户信息
  appInfo: { url: proxy.$config.wsURL }, //引用信息
  clientInfo: {}, //客户端信息
  serviceStyle: {
    inviteStyle:{}
  }, //在线客服样式
  defaultNickname: `新客户${Math.round(Math.random() * 899 + 100)}`,
  defaultAvatar: '',
  robotEnable: false, //是否接入机器人
  isToken: false, //是否获取token
  transferType: 2, //转接类型 0-人转人，1-机转人，2-点击
  closeSessionEnable: true, //是否可以关闭在线客服会话
  agentEnable: false, //是否接入客服
  localCustInfo: {}, //缓存客服信息
  robotId: null, //邀请机器人id
  groupId: null //邀请客服组
})
const localKey = computed(() => {
  return `cacheCustInfo_${page.appInfo.orgId}_${page.appInfo.appId}`
})
const init = () => {
  let params = route.params
  if (!params.orgId || !params.appId) {
    return ElMessage.error('参数错误')
  }
  page.appInfo.appId = params.appId
  page.appInfo.orgId = params.orgId
  page.appInfo.code = route.query?.code //公众号网页授权code
  page.pageStatus = 1
  // 获取公共token
  getCommentToken()
  // 缓存orgId
  localStorage.setItem('orgId', params.orgId)
}
// 获取公共token
const getCommentToken = async () => {
  // 获取token
  let requestKey = utils.generateUUID()
  localStorage.setItem('requestKey', requestKey)
  // orgId: appInfo.orgId, appId: appInfo.appId,
  let data = { requestKey: requestKey }
  try {
    let res = await proxy.$http.get('/sys/getTouristToken', { params: data })
    let token = res.data?.token
    if (res.code === 0 && token) {
      // 设置token
      utils.setToken(res.data.token)
      // 设置刷新token
      utils.setRefreshToken(res.data.refreshToken)
      page.isToken = true
      // 获取样式信息
      getPageStyle()
      // 根据应用id获取应用信息
      let res1 = await proxy.$http.post(`/cs/csthirdplatform/infoByAppId`, { appId: page.appInfo.appId, orgId: page.appInfo.orgId })
      if (res1.code === 0) {
        if (res1.data) {
          page.appInfo.type = parseInt(res1.data.serviceType || 2) //应用类型
          page.appInfo.isAuthorize = JSON.parse(res1.data.businessInfo)?.isAuthorize || false
          if (page.appInfo.type === 2 && page.appInfo.isAuthorize) {
            // 微信公众号
            initGzh()
          } else {
            // 其他类型 H5
            initH5()
          }
        } else {
          ElMessage.error('未获取到应用信息!')
        }
      } else {
        ElMessage.error(res1.msg || '获取应用信息失败!')
      }
    } else {
      ElMessage.error(res.msg || '获取不到token')
      page.isToken = false
    }
    
  } catch (err) {
    page.isToken = false
  }
}
// 微信公众号流程
const chatMsgAuthorizeRef = ref(null)
const initGzh = async () => {
  // 获取openid
  let params = { id: page.appInfo.appId, code: page.appInfo.code, orgId: page.appInfo.orgId }
  let res = await proxy.$http.post('/cs/csthirdplatform/getWeChatOauthToken', params)
  if (res.code === 0) {
    page.localCustInfo.openid = res.data.openid
    let res1 = await proxy.$http.post(`cust/custinfo/wxCust`, { openid: page.localCustInfo.openid })
    if (res1.code === 0) {
      if (res1.data && Object.keys(res1.data).length > 0) {
        page.localCustInfo.nickname = res1.data.custName || page.defaultNickname
        page.localCustInfo.avatar = res1.data.custAvatar || page.defaultAvatar
        page.localCustInfo.mobile = res1.data.mobile || ''
        localStorage.setItem(localKey.value, JSON.stringify(page.localCustInfo))
        getServerInfo()
      }
    } else if (res1.code === -1) {
      nextTick(() => {
        chatMsgAuthorizeRef.value.open()
      })
    } else {
      ElMessage.error(res1.msg || '获取openid失败！')
    }
  } else {
    ElMessage.error(res.msg || '获取openid失败！')
  }
}
// H5流程
const initH5 = () => {
  // 没有缓存并且要强制授权
  let cacheCustInfo = localStorage.getItem(localKey.value)
  if (page.appInfo.isAuthorize && (!cacheCustInfo || cacheCustInfo === '{}')) {
    nextTick(() => {
      chatMsgAuthorizeRef.value.open()
    })
  } else {
    initLocalCust()
    getServerInfo()
  }
}
// 保存用户信息并初始化
const handleSetCustInfo = () => {
  page.localCustInfo.nickname = data.name
  page.localCustInfo.mobile = data.mobile
  page.localCustInfo.openid = page.localCustInfo.openid || `local_${new Date().getTime()}`
  page.localCustInfo.avatar = page.defaultAvatar
  localStorage.setItem(localKey.value, JSON.stringify(page.localCustInfo))
  getServerInfo()
}
// 初始化客户信息
const initLocalCust = () => {
  let query = route.query
  if (query && query.openid) {
    page.localCustInfo.openid = query.openid
    page.localCustInfo.nickname = query.nickname || page.defaultNickname
    page.localCustInfo.avatar = query.avatar || page.defaultAvatar
    page.localCustInfo.mobile = query.mobile || ''
  } else {
    let cacheCustInfo = localStorage.getItem(localKey.value)
    if (cacheCustInfo && cacheCustInfo != '{}') {
      cacheCustInfo = JSON.parse(cacheCustInfo)
      page.localCustInfo.openid = cacheCustInfo.openid
      page.localCustInfo.nickname = cacheCustInfo.nickname
      page.localCustInfo.avatar = cacheCustInfo.avatar || page.defaultAvatar
      page.localCustInfo.mobile = cacheCustInfo.mobile
    } else {
      page.localCustInfo.openid = page.localCustInfo.openid || `local_${new Date().getTime()}`
      page.localCustInfo.nickname = page.defaultNickname
      page.localCustInfo.avatar = page.defaultAvatar
      page.localCustInfo.mobile = query.mobile || ''
    }
  }
  localStorage.setItem(localKey.value, JSON.stringify(page.localCustInfo))
  query = null
}
const serviceRef = ref(null)
const robotRef = ref(null)
const refreshServerInfo = () => { 
  return new Promise((resolve) => { 
    let data = {
      orgId: page.appInfo.orgId,
      appId: page.appInfo.appId,
      openid: page.localCustInfo.openid,
      mobile: page.localCustInfo.mobile,
      nickname: page.localCustInfo.nickname,
      avatar: page.localCustInfo.avatar,
      clientType: page.clientInfo.clientType || 1
    }
    try {
      let resPromise = proxy.$http.post('/app/custClient/client/init', data)
      resPromise.then((res) => {
        if (res.code === 0) {
          // 应用信息
          let info = res.data.appInfoResponse
          console.log(res.data)
          page.appInfo.appName = info.appName
          page.appInfo.appImg = info.appImg
          page.appInfo.appDesc = info.appDesc
          // 客户信息
          page.custInfo = res.data.custInfoResponse
          if (!page.custInfo || !page.custInfo.custAvatar) {
            page.custInfo.custAvatar = page.defaultAvatar
          }
          localStorage.setItem('senderId', page.custInfo.custId)
          // 客户端信息
          page.clientInfo = res.data.clientInfoResponse
          // 是否转机器人
          page.robotEnable = info.robotEnable === 1 ? true : false
          page.closeSessionEnable = info.closeEnable === 1 ? true : false
          resolve()
        } else {
          ElMessage.error(res.msg)
        }
      })
    } catch (err) {
      ElMessage.error('网络连接异常，请稍候再试')
    }
  })
}
const getServerInfo = () => {
  return new Promise((resolve) => { 
    let data = {
      orgId: page.appInfo.orgId,
      appId: page.appInfo.appId,
      openid: page.localCustInfo.openid,
      mobile: page.localCustInfo.mobile,
      nickname: page.localCustInfo.nickname,
      avatar: page.localCustInfo.avatar,
      clientType: page.clientInfo.clientType || 1
    }
    try {
      let resPromise = proxy.$http.post('/app/custClient/client/init', data)
      resPromise.then((res) => {
        if (res.code === 0) {
          // 应用信息
          let info = res.data.appInfoResponse
          console.log(res.data)
          page.appInfo.appName = info.appName
          page.appInfo.appImg = info.appImg
          page.appInfo.appDesc = info.appDesc
          // 客户信息
          page.custInfo = res.data.custInfoResponse
          if (page.custInfo && page.custInfo.custAvatar) {
            page.custInfo.custAvatar = page.defaultAvatar
          }
          localStorage.setItem('senderId', page.custInfo.custId)
          // 客户端信息
          page.clientInfo = res.data.clientInfoResponse
          // 是否转机器人
          page.robotEnable = info.robotEnable === 1 ? true : false
          page.closeSessionEnable = info.closeEnable === 1 ? true : false
          getSessionStatus().then((data) => {
            console.log(data)
            let sessionError = false
            if (!data) return
            let oldStatus = null
            if (data.length === 0) {
              oldStatus = 1
            } else if (data[0].agentNetStatus === 0) {
              // 网络异常
              oldStatus = 2
              sessionError = true
            } else if (data[0].agentNetStatus === 1) {
              // 网络正常
              oldStatus = 2
            }
            if (oldStatus) {
              page.pageStatus = oldStatus === 1 && page.robotEnable ? 1 : 2
            } else {
              page.pageStatus = info.robotEnable
            }
            if (page.pageStatus === 2) {
              // 建立连接
              nextTick(() => {
                serviceRef.value && serviceRef.value.init(sessionError)
              })
            } else if (page.pageStatus === 1) {
              // 初始化机器人
              nextTick(() => {
                robotRef.value && robotRef.value.init()
              })
            }
            oldStatus = null
            sessionError = null
          })
          resolve()
        } else {
          ElMessage.error(res.msg)
        }
      })
    } catch (err) {
      ElMessage.error('网络连接异常，请稍候再试')
    }
  })
}
const getSessionStatus = () => {
  return new Promise((resolve, reject) => {
    proxy.$http
      .post('/app/custClient/getSessionList', { custId: page.custInfo.custId, orgId: page.appInfo.orgId })
      .then((res) => {
        if (res.code === 0) {
          resolve(res.data)
        } else {
          reject([])
          ElMessage.error(res.msg)
        }
      })
  })
}
// 转接机器人
const handleSwitchRobot = () => {
  refreshServerInfo().then(() => { 
    if (!page.robotEnable || page.pageStatus === 1) return
    page.pageStatus = 1
    // 初始化机器人
    nextTick(() => {
      robotRef.value.init()
    })
  })
}

const connnectService = () => { 
  // 设置页面状态
  refreshServerInfo().then(() => { 
    page.pageStatus = 2
    // 初始化socket
    nextTick(() => {
      serviceRef.value.openSession()
    })
  })
}
// 转在线客服
const handleSwitchService = (data) => {
  // 设置页面状态
  refreshServerInfo().then(() => { 
    page.pageStatus = 2
    if (Object.keys(data).length > 0) {
      page.custInfo.groupId = data?.groupId //转接组ID
      page.transferType = data?.transferType //转接类型
    }
    // 初始化socket
    nextTick(() => {
      serviceRef.value.init()
    })
  })
}
// socket重连设置页面状态
const hanldeReconnect = () => {
  page.pageStatus = 2
}
// 结束会话
const handleQuitChat = () => {
  page.pageStatus = 1
  // 初始化机器人
  nextTick(() => {
    robotRef.value.init()
  })
}
// 获取在线客服样式
const getPageStyle = async () => {
  let query = { orgId: page.appInfo.orgId }
  let res = await proxy.$http.post('/app/custClient/client/getConfig', query)
  if (res.code === 0) {
    console.log(res.data)
    let { config, invite, comment } = res.data
    // 会话邀请样式
    page.serviceStyle.inviteStyle = invite || {}

    // 评价样式
    page.serviceStyle.commentStyle = comment || {}
    if (isMobile()) {
      isWx().then((type) => {
        page.serviceStyle.styleConfig = type === 'no-wx' ? config?.h5Config : config?.appConfig
        page.defaultAvatar = page.serviceStyle.styleConfig.defaultAvatar
        setDefaultAvatar()
      })
    } else {
      page.serviceStyle.styleConfig = config?.webConfig
      page.defaultAvatar = page.serviceStyle.styleConfig?.defaultAvatar
      setDefaultAvatar()
    }
  } else {
    ElMessage.error(res.msg)
  }
}

const setDefaultAvatar = () => {
  let cacheCustInfo = localStorage.getItem(localKey.value)
  if (cacheCustInfo && cacheCustInfo != '{}') {
    cacheCustInfo = JSON.parse(cacheCustInfo)
    cacheCustInfo.avatar = page.defaultAvatar
    localStorage.setItem(localKey.value, JSON.stringify(cacheCustInfo))
  }
}
init()
// 接受会话邀请
const inviteRef = ref(null)
let timer
const handleAccept = () => {}
// 设置会话邀请
const setInvite = () => {
  let { inviteStyle } = page.serviceStyle
  // 判断是否是web 端 + 开启会话邀请
  if (typeof window !== 'undefined' && inviteStyle.enabled === 1) {
    // 一天内会话邀请
    let inviteData = localStorage.getItem('inviteData')
    let now = new Date().getTime()
    if (
      !inviteData ||
      Object.keys(inviteData).length === 0 ||
      inviteData?.openid !== page.localCustInfo.openid ||
      isSameDay(now, inviteData?.time)
    ) {
      inviteData = {
        inviteNum: 0, //会话邀请次数
        time: now, //会话邀请天
        isRefuse: false, //是否拒绝,
        openid: page.localCustInfo.openid
      }
    }
    // 重置访问是否拒绝
    inviteData.isRefuse = false
    if (inviteStyle.secondsAfter.enabled === 1) {
      clearTimer()
      let times = inviteStyle.secondsAfter.value || 3 * 1000
      timer = setTimeout(() => {
        inviteRef.value.open()
      }, times)
    }
  }
}
// 清除定时器
const clearTimer = () => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}
onBeforeUnmount(() => {
  clearTimer()
})
</script>

<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  .chat-panel {
    background: #fff;
    width: 600px;
    height: 600px;
  }
  @media screen and (max-width: 960px) {
    .chat-panel {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
